import React from 'react'
import {
  DOMICILE_FISCALE_DIFFERENT,
  DONT_CHANGE_DOMICILE_FISCALE,
} from '../../enums/common'
import YesNoButtons from '../formGroup/YesNoButtons'
import ReasonDifferentDomicile from './ReasonDifferentDomicile'
import { IDomicileFiscale } from '../../interfaces/Step5'
import { getItemSuffix } from '../../utils/getItemSuffix'

function DomicileFiscale(props: IDomicileFiscale) {
  const { type, folderData, form, item } = props
  const { errors, register, watch } = form

  if (type === DONT_CHANGE_DOMICILE_FISCALE) {
    return <></>
  }

  const is_tax_country_france_input = `is_tax_country_france${getItemSuffix(
    item
  )}`
  const fiscalAddressCountrySuffix = `fiscal_address_country${getItemSuffix(
    item
  )}`

  const is_tax_country_france = folderData[is_tax_country_france_input]

  const watchInputValue: string = watch(is_tax_country_france_input)
  const watchAdressCountryInputValue = watch(fiscalAddressCountrySuffix)

  if (
    type === DOMICILE_FISCALE_DIFFERENT &&
    watchAdressCountryInputValue === 'Autre'
  ) {
    return (
      <div className="col12 mb6lg mb15">
        <p>Votre pays de résidence légale et de résidence fiscale diffèrent</p>
        <ReasonDifferentDomicile {...{ ...props }} />
      </div>
    )
  }
  return (
    <div className="col12 mb15">
      <div className="row">
        <div className="col12 colLg10 colXl7">
          <YesNoButtons
            id={is_tax_country_france_input}
            name={is_tax_country_france_input}
            label="Est-ce que votre pays de résidence légale et de résidence fiscale diffèrent ?"
            value={is_tax_country_france || ''}
            register={register({ required: true })}
            labelClassName="mb15"
            error={errors[is_tax_country_france_input]}
          />
          {watchInputValue === '0' && (
            <ReasonDifferentDomicile {...{ ...props }} />
          )}
        </div>
      </div>
    </div>
  )
}

export default DomicileFiscale
